import { useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { setLocation, setNavigateFunction } from './RoutingService'

function RoutingServiceInitializer(): null {
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        setNavigateFunction(navigate)
    }, [navigate])

    useEffect(() => {
        setLocation(location)
    }, [location])

    return null // This component doesn't render anything
}

export default RoutingServiceInitializer
